import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDefault } from '../../../redux/actions/snackbarActions';
import { Snackbar, SnackbarContent, IconButton, Icon, Typography } from '@material-ui/core';
import { instajobTheme } from '../../helpers/instajobTheme';

class DefaultSnackbar extends Component {
    render() {
        const { message, show, hideDefault } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={show}
                autoHideDuration={6000}
                onClose={hideDefault}>
                <SnackbarContent
                    aria-describedby="client-snackbar"
                    style={{ backgroundColor: '#212121' }}
                    message={
                        <Typography variant="body1" style={{ padding: 0 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Icon style={{ marginRight: 15 }}>info</Icon>
                                {message}
                            </div>
                        </Typography>
                    }
                    action={[
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={hideDefault}>
                            <Icon>close</Icon>
                        </IconButton>
                    ]}
                />
            </Snackbar>
        );
    }
}

const mapDefaultActionsToProps = dispatch => (
    bindActionCreators({ hideDefault }, dispatch)
);

const mapDefaultStateToProps = store => ({
    message: store.snackbarState.message.default,
    show: store.snackbarState.show.default
});

export default connect(mapDefaultStateToProps, mapDefaultActionsToProps)(DefaultSnackbar);